/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content-with-filled-button[_ngcontent-%COMP%]{background-color:#fff!important;min-height:calc(100vh - 305px);margin-top:32px}@media (min-width:768px){.content-with-filled-button[_ngcontent-%COMP%]{min-height:calc(100vh - 360px)}}.content[_ngcontent-%COMP%]{min-height:auto;display:inline-flex}.sub-title[_ngcontent-%COMP%]{font-size:24px;line-height:32px;color:#231d19;font-weight:300}@media (min-width:1280px){.sub-title[_ngcontent-%COMP%]{font-size:32px}}"];
export { styles as styles };
